import { Component, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { BadgeComponent, IconContainerComponent } from '@core/user-interface-legacy';
import { TicketsChatService } from '@tellent-ask-hr/tickets-logic';

@Component({
  selector: 'tlc-tickets-welcome',
  template: `
    <rt-icon-container
      name="local-activity"
      color="colorIconDefault"
      background="colorBgNeutralDefault"
      size="small"
      containerSize="large"
      margin-right-small
    />
    <span text-small text-darkest text-weight-semi-bold>
      {{ 'tlc.ask_hr.requests.chat.welcome_heading' | translate }}
    </span>
    @if (viewCounter(); as counter) {
      <rt-badge [text]="counter.count" color="counter-default" margin-left-small-x />
    }
  `,
  imports: [IconContainerComponent, BadgeComponent, TranslatePipe],
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
      }
    `,
  ],
})
export class TicketsWelcomeComponent {
  private readonly ticketsChatService = inject(TicketsChatService);

  protected viewCounter = this.ticketsChatService.getChatCounter();
}
